export const artists = [
  { name: "Calin", slug: "calin" },
  { name: "STEIN27", slug: "stein27" },
  { name: "KOJO", slug: "kojo" },
  { name: "SIMILIVINLIFE", slug: "similivinlife" },
  { name: "Lajfr", slug: "lajfr" }
];
